window.addEventListener('pplrAppInitiated' , function(e) {
    const sourceElement = document.querySelector('.pplr_atc_form');
    const targetHeader = document.querySelector('.swatch-block-header--custom');
    const disclaimer = document.querySelector('.product-gallery__disclaimer');

    if (sourceElement && targetHeader) {
        targetHeader.classList.remove('disable-block');
    }

    if (disclaimer) {
        disclaimer.classList.remove('disable-text')
    }
})

window.addEventListener('DOMContentLoaded', () => {
    initializeButton()
});

function validateForm() {
    const form = document.querySelector('.shopify-product-form');
    const error_message = document.querySelector('.td-error-message');
    const error_message_list = document.querySelector('.td-error-message-list');
    const invalidControls = form.querySelectorAll('input:invalid, select:invalid, textarea:invalid');

    // Group invalid controls by their data-group attribute
    const groupMap = [];
    if (invalidControls.length > 0) {
        invalidControls.forEach(control => {
            // Only consider controls with a data-group attribute
            const group = control.getAttribute('data-group');
            if (group) {
                if (!groupMap.includes(group)) {
                    groupMap.push(group);
                }
            }
        });
    }

    if (error_message_list) {
        error_message_list.innerHTML = '';
        groupMap.forEach(group => {
            const groupError = document.createElement('li');
            groupError.classList.add('td-error-message-group');
            groupError.textContent = `Please select a ${group}`;
            error_message_list.appendChild(groupError);
        });
    
    }

    if (invalidControls.length > 0) {
        error_message.classList.add("active")
    } else {
        error_message.classList.remove("active")
    }
}

function initializeButton() {
    let atcButton = document.querySelector('.td-sp-button__pdp.add_to_cart')
    if (atcButton) {
        atcButton.addEventListener('click', () => {
            validateForm()
        })
    }
}